import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { ColorSwitcherComponent } from './color-switcher/color-switcher.component';
import { DialogPopupComponent } from './dialog-popup/dialog-popup.component';
import { PageButtonsBarComponent } from './page-buttons-bar/page-buttons-bar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientRelationPopupComponent } from './client-relation-popup/client-relation-popup.component';
import { ClientEmploymentPopupComponent } from './client-employment-popup/client-employment-popup.component';
import { ClientDocsPopupComponent } from './client-docs-popup/client-docs-popup.component';



@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        HorizontalMenuComponent,
        ColorSwitcherComponent,
        PageButtonsBarComponent,
        NgbModule,
        DialogPopupComponent,
        PageButtonsBarComponent,
        ClientRelationPopupComponent,
        ClientEmploymentPopupComponent,
        ClientDocsPopupComponent 
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        // PerfectScrollbarModule
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        HorizontalMenuComponent,
        ColorSwitcherComponent,
        DialogPopupComponent,
        PageButtonsBarComponent,
        ClientRelationPopupComponent,
        ClientEmploymentPopupComponent,
        ClientDocsPopupComponent
    ],
    providers: [ ],
})
export class SharedModule { }
